export type StickyEvent = {
    stuck: boolean,
    target: Element
}

const fireEvent = (stuck: boolean, target: Element): void => {
    const e = new CustomEvent<StickyEvent>('sticky-change', { detail: { stuck, target } });
    document.dispatchEvent(e);
};

export const observe = (...containers: Element[]): void => {
    const observer = new IntersectionObserver(([e]) => {
        const isSticky = e.intersectionRatio < 1;
        fireEvent(isSticky, e.target);
    }, { threshold: [1] });

    for (const container of containers) {
        observer.observe(container);
    }
};
